export const mwImage = (url: string) => {
    return url?.split('https://wpadmin.middleware.io/wp-content').join('https://middleware.io/wp-content')
}

/** Removes WordPress image size suffix (e.g. -96x96, -150x150) to get full-size image */
export const stripImageSizeSuffix = (url: string | undefined | null): string => {
    if (!url) return '';
    return url.replace(/-\d+x\d+(\.[^.]+)$/, '$1');
}